import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CoverItemAdditionalQuestionComponent } from './cover-item-additional-question.component';
import { CoverItemListComponent } from './cover-item-list/cover-item-list.component';
import { SubCoveredItemsListComponent } from './sub-covered-items-list/sub-covered-items-list.component';

const routes: Routes = [
  {
    path: '', 
    component: CoverItemAdditionalQuestionComponent,
    children: [
      {
        path: 'claim-cover-item-list',
        component: CoverItemListComponent
      },
      {
        path: 'claim-sub-covered-item-list/:id',
        component: SubCoveredItemsListComponent
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CoverItemAdditionalQuestionRoutingModule { }
